import { createSelector } from '@ngrx/store';
import { getWizzardSimpleItem } from '@shared/state/wizzard/selectors';
import { getProductsWithRestrictions } from '@shared/state/productRestrictions/selectors';

export const hasWizzardSimpleItemRestriction = createSelector(
    getWizzardSimpleItem,
    getProductsWithRestrictions,
    (wizzardSimpleItem, productRestrictions) => productRestrictions?.some((productRestriction) => productRestriction?.ProductId === wizzardSimpleItem?.ProductId) || false,
);
